import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import Paper from "@material-ui/core/Paper";
import { PremissionChecker } from "../../../services/PremissionChecker";
function CampusCourses() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);
  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [addCourseLoading, setAddCourseLoading] = useState(false);

  const [addCourseModal, setAddCourseModal] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [campusId, setCampusId] = useState("");

  const [editCourseModal, setEditCourseModal] = useState(false);
  const [editCampusCourseId, setEditCampusCourseId] = useState("");
  const [editCourseId, setEditCourseId] = useState("");
  const [editCampusId, setEditCampusId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteableCourse, setDeleteableCourse] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [campusData, setCampusData] = useState(user.campuses || []);

  useEffect(() => {
    getCourses();
  }, []);

  const getCourses = async () => {
    setloading(true);
    await fetch(`${baseUrl}/course`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getCampusCourses = async (campusId) => {
    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    setloading(true);
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const addCourseHandler = async () => {
    if (campusId == "" || courseId == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      campus_id: campusId,
      course_id: courseId,
    };
    setAddCourseLoading(true);

    await fetch(`${baseUrl}/campus-courses`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setAddCourseModal(false);
            setAddCourseLoading(false);
            getCampusCourses(campusId);
            alert.success("Course successfully added");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddCourseModal(false);
            setAddCourseLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddCourseModal(false);
            setAddCourseLoading(false);
          }
        })
      )
      .catch((err) => {
        setAddCourseLoading(false);
        setAddCourseModal(false);
        console.log(err);
      });
  };

  const getEditCampusCourse = async (id) => {
    await fetch(`${baseUrl}/campus-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditCampusCourseId(data.payload?.id);
          setEditCampusId(data.payload?.campus_id);
          setEditCourseId(data.payload?.course_id);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateCampusCourseHandler = async () => {
    if (editCampusId == "" || editCourseId == "") {
      return alert.error("Campus Or Course Is Required");
    }

    setSubmitLoading(true);
    const data = {
      campus_id: editCampusId,
      course_id: editCourseId,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/campus-courses/${editCampusCourseId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Campus Course Successfully Updated");
            getCampusCourses(campusId);
            setEditCourseModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditCourseModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditCourseModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteCourseHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/campus-courses/${deleteableCourse}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getCampusCourses(campusId);
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddCourseModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Course
          </button>
        </div>

        <div className="row mt-5">
          <div className="col-md-6">
            <label>
              <b>Select Campus</b> <span style={{ color: "red" }}>*</span>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="campus_id"
                aria-label="Default select example"
                onChange={(e) => {
                  onCampusChange(e.target.value);
                }}
              >
                <option value=""> Select Campus</option>
                {campusData &&
                  campusData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        <Table style={{ margin: 10 }}>
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Course Name</th>
              <th>Course Type</th>
              <th>Update</th>
              {PremissionChecker(user, "campus.can_delete_course") ? (
                <th>Delete</th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {campusCourseData?.map((campusCourse, index) => (
              <tr className="text-center" key={index}>
                <td>{campusCourse.id}</td>
                <td>{campusCourse?.course?.name}</td>
                <td>{campusCourse?.course?.course_type}</td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                    onClick={() => {
                      getEditCampusCourse(campusCourse?.id);
                      setEditCourseId(campusCourse?.id);
                      setEditCourseModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Files/Download.svg"
                        )}
                      />
                    </span>
                  </a>
                </td>
                {PremissionChecker(user, "campus.can_delete_course") ? (
                  <td>
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                      onClick={() => {
                        setDeleteableCourse(campusCourse?.id);
                        setdeleteModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add Campus Course Modal */}
        <Modal show={addCourseModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Campus Course
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <label htmlFor="campus_id">
                Select Campus<span style={{ color: "red" }}>*</span>
              </label>
              <select
                style={{ height: 40 }}
                className="form-select form-control"
                name="campus_id"
                aria-label="Default select example"
                onChange={(e) => {
                  setCampusId(e.target.value);
                }}
              >
                <option value=""> Select Campus</option>
                {campusData &&
                  campusData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="row mb-4">
              <label htmlFor="course">
                Select Course<span style={{ color: "red" }}>*</span>
              </label>

              <select
                className="form-select form-control"
                name="course"
                onChange={(e) => {
                  if (e.value == 0) {
                    setisallfields(true);
                  } else {
                    setisallfields(false);
                  }
                  setCourseId(e.target.value);
                }}
                style={{ backgroundColor: "white" }}
                aria-label="Default select example"
              >
                <option value="">Select Course</option>
                {courseData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addCourseLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addCourseHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddCourseModal(false);
                setisallfields(false);
                setCourseId("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Campus Course Modal */}
        <Modal show={editCourseModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Campus Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label htmlFor="campus_id">
                Select Campus<span style={{ color: "red" }}>*</span>
              </label>
              <select
                style={{ height: 40 }}
                className="form-select form-control"
                name="campus_id"
                value={editCampusId}
                aria-label="Default select example"
                onChange={(e) => {
                  setEditCampusId(e.target.value);
                }}
              >
                <option value=""> Select Campus</option>
                {campusData &&
                  campusData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="row mb-4">
              <label htmlFor="course">
                Select Course<span style={{ color: "red" }}>*</span>
              </label>

              <select
                className="form-select form-control"
                name="course"
                value={editCourseId}
                onChange={(e) => {
                  if (e.value == 0) {
                    setisallfields(true);
                  } else {
                    setisallfields(false);
                  }
                  setEditCourseId(e.target.value);
                }}
                style={{ backgroundColor: "white" }}
                aria-label="Default select example"
              >
                <option value="">Select Course</option>
                {courseData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateCampusCourseHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditCourseModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Campus Course Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this campus course?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteCourseHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default CampusCourses;
